import { useEffect } from 'react';

export const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

// classコンポーネントではこれを使う
// classがFCに全て置き換わったら削除する
export const scrollToTop = () => {
  window.scrollTo(0, 0);
};
